import { Text } from '$components'
import { ReactNode } from 'react'

export type SettingsCardSubheadingProps = {
  children?: ReactNode
}

export function SettingsCardSubheading({ children }: SettingsCardSubheadingProps) {

  return (
    <Text className="mb-stack-section">
      { children }
    </Text>
  )
}
